module.exports = __webpack_public_path__ + "static/media/33-10.7c6d4e57.mp3";